//RAW DATA
export const GET_SELECTED_DEVICE_ORG_DATA = 'GET_DEVICE_ORG_DATA';
export const ERROR_SELECTED_DEVICE_ORG_DATA = 'ERROR_DEVICE_ORG_DATA';
export const CLEAR_SELECTED_DEVICE_ORG_DATA = 'CLEAR_DEVICE_ORG_DATA';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';
export const GET_ORG_LIST = 'GET_ORG_LIST';
export const ERROR_ORG_LIST = 'ERROR_ORG_LIST';